<template>
  <div>
    <header class="homapt-header" v-bind:style="backgroundImage">
      <div class="dark-overlay">
        <div class="container">
          <div class="row header-row h-100">
            <div class="col-12 my-auto text-center">
              <h1 class="title"> HomApt Rewards</h1>
              <br>
            </div>
          </div>
        </div>
      </div>
    </header>
    <div class="container">
      <div class="row example-row">
        <div class="col my-auto text-center">
          <h3>What is the HomApt Reward Program?</h3>
          <p>The HomApt Reward Program is quick and easy to join. All you need to do is use a HomApt Realtor to find the right house for you. Our full service realtor will
            use modern tools and services to find potential houses, handle all of the paperwork and ensure you can close on the house in a timely manner. Your reward amount will be applied automatically at Closing. Closing simply means
            that all of the paperwork is done and you can move into your new home!
          </p>
          <p>If you list your house with a HomApt Realtor, you get an additional reward to use on purchasing your next home.</p>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row example-row">
        <div class="col my-auto text-center">
          <h3>Let's see how much you can get!</h3>
        </div>
      </div>
    </div>
    <div class="homapt-table container">
      <div class="row homapt-table-row">
        <div class="col text-center my-auto left-column yellow-background">
          <p class="table-text"><b>Home Purchase Price</b></p>
        </div>
        <div class="col text-center my-auto yellow-background">
          <p class="table-text"><b>Reward Amount*</b></p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto left-column">
          <p class="table-text">$ 0 - $100,000</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">$100**</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto left-column">
          <p class="table-text">$100,001 - $250,000</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">10%</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto left-column">
          <p class="table-text">$250,000 - $500,000</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">15%</p>
        </div>
      </div>
      <div class="row homapt-table-row">
        <div class="col text-center my-auto left-column">
          <p class="table-text">$500,000 +</p>
        </div>
        <div class="col text-center my-auto">
          <p class="table-text">20%</p>
        </div>
      </div>
      <div class="row text-center">
        <div class="col conclusion">
          <h3 class="table-conclusion">Save an additional 5% if you list your current home with us!</h3>
        </div>
      </div>
      <div class="row text-left">
        <div class="col">
          <p class="table-text">*Reward is a percentage of Buyer Agent commission based on home purchase price. Reward amount will be applied automatically at closing.</p>
          <p class="table-text">**Reward is a fixed price if purchasing a home for $100,000 or less.</p>
        </div>
      </div>
    </div>
    <div class="jumbotron">
      <div class="row">
        <div class="col text-center">
          <h3>Get a HomApt Agent Today!</h3>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 offset-lg-3 my-auto">
          <input v-model="email" placeholder="Enter Your Email" class="form-control form-control-md">
        </div>
        <div class="col-lg-2 my-auto">
          <button v-on:click="submitEmail" class="btn btn-secondary">Submit</button>
        </div>
      </div>
      <div class="row needs-padding">
        <div class="col-lg-8 offset-lg-2">
          <b-alert variant="warning"
            dismissible
            :show="unavailable"
            @dismissed="unavailable=false">
            Service Unavailable, Please Try Again Later
          </b-alert>
          <b-alert variant="warning"
            dismissible
            :show="emailInvalid"
            @dismissed="emailInvalid=false">
            The email you have entered is invalid.
          </b-alert>
          <b-alert variant="success"
            dismissible
            :show="success"
            @dismissed="success=false">
            Thanks for contacting HomApt, someone will reach out to you shortly!
          </b-alert>
        </div>
      </div>
      <div class="col-lg text-center my-auto">
        <br>
        <h4>A HomApt Realtor will send a no obligation email to you within one hour.</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: null,
      success: false,
      unavailable: false,
      emailInvalid: false
    }
  },
  computed: {
    backgroundImage () {
      return 'background-image: url("https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/xlarge/uploads/Wallet.jpg")'
    }
  },
  methods: {
    validateEmail () {
      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(this.email)) {
        this.emailInvalid = true
        return true
      } else {
        this.emailInvalid = false
      }
    },
    async submitEmail () {
      if (this.validateEmail()) return
      this.emailInvalid = false
      var client = this.$store.getters.getEmailApigClientFactory
      var params = {}
      var pathTemplate = '/email'
      var method = 'POST'
      var additionalParams = {}
      var body = {
        email: this.email
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.success = true
      } catch (error) {
        this.unavailable = true
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.container {
  height: 100%;
}

.homapt-header {
  height: 50vh !important;
  background-color: rgba(52, 58, 64, .8);
}

.title {
  color: white !important;
}

.example-row {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.price-difference-row {
  background-color: #feedaa;
  margin-bottom: 1rem;
}

.homapt-table {
  border-style: solid;
  border-width: 1px;
  margin-bottom: 2rem;
}

.homapt-table-row {
  border-bottom-style: solid;
  border-width: 1px;
}

.table-text {
  margin-bottom: 1rem;
  margin-top: 1rem;
}

.left-column {
  border-right-style: solid;
  border-width: 1px;
}

.table-conclusion {
  padding-top: 1rem;
  padding-bottom: 1rem;
  color: white !important;
}

.conclusion {
  background-color: rgba(52, 58, 64, 1);
}

.yellow-background {
  background-color: var(--secondary-background-color);
}
</style>



// WEBPACK FOOTER //
// src/components/realty/Rebates.vue